import { useCallback, useState } from 'react';

import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Label from '@/components/form/Label';
import { useMediaQuery } from '@/hooks';
import DeleteIcon from '@/icons/delete.svg';
import Upload from '@/icons/upload.svg';

function ImageDropdown(props) {
	const sm = useMediaQuery('sm');

	const { setFormFile } = props;

	const { t } = useTranslation();

	const [file, setFile] = useState(null);

	const onDrop = useCallback(acceptedFiles => {
		setFile(acceptedFiles[0]);
		setFormFile(acceptedFiles[0]);
	}, []);

	const onDeleteFile = useCallback(event => {
		event.stopPropagation();
		setFile(null);
		setFormFile(null);
	}, []);

	const { getRootProps, getInputProps } = useDropzone({
		maxFiles: 1,
		accept: {
			'image/X': ['.jpeg', '.png', '.webp', '.jpg'],
			'application/pdf': ['.pdf']
		},
		onDrop
	});

	return (
		<div {...getRootProps()}>
			<Label htmlFor="picture">
				<div className="flex flex-row items-center justify-center gap-2 rounded-lg border border-dashed border-grey-500 px-3 py-[10px] hover:bg-grey-100 lg:justify-center">
					{file ? (
						<div className="flex flex-row items-center gap-2">
							{file.name}
							<Button
								className="p-0"
								variant="ghost"
								onClick={onDeleteFile}
							>
								<DeleteIcon className="h-[18px] w-[18px]" />
							</Button>
						</div>
					) : (
						<div className="flex cursor-pointer items-center gap-2 text-xs leading-5 lg:flex-row lg:text-sm lg:leading-7">
							<Upload />
							<div className="block items-center">
								<span className="gap-3 font-normal text-red lg:font-semibold">
									{t('contact.form.upload')}{' '}
								</span>
								<span className="font-normal text-grey-500">
									{t(
										sm
											? 'contact.form.optionalShort'
											: 'contact.form.optional'
									)}
								</span>
							</div>
						</div>
					)}
				</div>
			</Label>
			<input {...getInputProps()} />
		</div>
	);
}

export default ImageDropdown;
